/* Sky · Header JS · Mega-Menu Toggle, Mobile-Drawer, Sticky */
(function() {
  'use strict';

  /* Cart-Badge zentral synchronisieren — unabhängig vom ATC-Pfad.
     Hintergrund: Es gibt mehrere ATC-Flows (legacy <product-form>, sky-cart-form
     in sky-pdp-hero/sky-product-hero, upsell.js). Nur der legacy-Flow updated
     `cart-bubble` korrekt; die sky-cart-form-/upsell-Flows treffen nicht-existente
     Selektoren oder fetchen die Section gar nicht. Statt jeden Pfad einzeln zu
     fixen: fetch() für /cart/{add,change,update,clear}.js wrappen + auf bekannte
     cart:*-Events hören → eine Quelle der Wahrheit aus /cart.js holen. */
  initCartBubbleSync();

  function initCartBubbleSync() {
    let syncTimer = null;
    let seq = 0;

    function applyCount(count) {
      const badges = document.querySelectorAll('.sky-h__cart-count, #cart-drawer-toggle .float_count');
      badges.forEach(function(badge) {
        // MutationObserver auf .sky-h__cart-count togglet is-zero anhand textContent
        badge.textContent = String(count);
      });
    }

    function syncNow() {
      const myseq = ++seq;
      fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
        .then(function(r) { return r.ok ? r.json() : null; })
        .then(function(cart) {
          if (myseq !== seq) return; // neuere Sync läuft / ist fertig → stale Response verwerfen
          if (cart && typeof cart.item_count === 'number') applyCount(cart.item_count);
        })
        .catch(function() {});
    }

    function scheduleSync() {
      clearTimeout(syncTimer);
      syncTimer = setTimeout(syncNow, 120);
    }

    // 1) fetch()-Wrap: jede /cart/{add,change,update,clear}.js Mutation triggert Sync
    if (window.fetch) {
      const origFetch = window.fetch.bind(window);
      window.fetch = function(input, init) {
        const url = typeof input === 'string' ? input : (input && input.url) || '';
        const isCartMutation = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url);
        const p = origFetch(input, init);
        if (isCartMutation) {
          p.then(function() { scheduleSync(); }, function() {});
        }
        return p;
      };
    }

    // 2) Event-Listener als Redundanz (legacy theme-js dispatched diese Events)
    ['cart:item-added', 'cart:refresh:complete', 'cart:added', 'cart:updated',
     'cart:refresh', 'line-item:change:end', 'theme:cart:added', 'theme:cart-updated']
      .forEach(function(name) { document.addEventListener(name, scheduleSync); });
  }

  function boot() {
    const headers = document.querySelectorAll('sky-header');
    headers.forEach(initHeader);
    console.log('[sky-header] init done · headers:', headers.length);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  function initHeader(header) {
    if (header.dataset.skyInit === '1') return;
    header.dataset.skyInit = '1';

    /* ─── Mega-Menu Toggle ─── */
    const triggers = header.querySelectorAll('[data-mega-trigger]');
    const panels = header.querySelectorAll('.sky-h__mega');
    let activePanel = null;

    let readyTimer = null;

    function parseCssTime(value) {
      if (!value) return 0;
      const v = value.trim();
      if (v.endsWith('ms')) return parseFloat(v);
      if (v.endsWith('s')) return parseFloat(v) * 1000;
      return parseFloat(v) || 0;
    }

    function openPanel(handle) {
      panels.forEach(p => {
        p.classList.remove('is-ready');
        if (p.dataset.megaPanel === handle) {
          p.classList.add('is-open');
          p.setAttribute('aria-hidden', 'false');
          activePanel = p;
        } else {
          p.classList.remove('is-open');
          p.setAttribute('aria-hidden', 'true');
        }
      });
      triggers.forEach(t => {
        const isActive = t.dataset.megaTrigger === handle;
        t.setAttribute('aria-expanded', isActive ? 'true' : 'false');
        t.closest('.sky-h__item').classList.toggle('is-open', isActive);
      });
      document.body.classList.add('sky-h-mega-open');

      // Stagger-Index pro Card setzen (CSS rechnet Delay) + Wartezeit nativ aus CSS-Werten ableiten
      clearTimeout(readyTimer);
      if (activePanel) {
        const cards = activePanel.querySelectorAll('.sky-mc');
        cards.forEach((c, i) => c.style.setProperty('--i', i));

        const panelCs = getComputedStyle(activePanel);
        const startMs = parseCssTime(panelCs.getPropertyValue('--mc-start')) || 150;
        const staggerMs = parseCssTime(panelCs.getPropertyValue('--mc-stagger')) || 280;
        let durationMs = parseCssTime(panelCs.getPropertyValue('--mc-duration'));
        if (!durationMs && cards[0]) {
          const durs = getComputedStyle(cards[0]).transitionDuration.split(',').map(parseCssTime);
          durationMs = Math.max.apply(null, durs);
        }
        if (!durationMs) durationMs = 1000;

        const waitMs = startMs + Math.max(0, cards.length - 1) * staggerMs + durationMs + 80;
        readyTimer = setTimeout(() => {
          if (activePanel && activePanel.classList.contains('is-open')) {
            activePanel.classList.add('is-ready');
          }
        }, waitMs);
      }
    }

    function closePanels() {
      clearTimeout(readyTimer);
      panels.forEach(p => {
        p.classList.remove('is-open');
        p.classList.remove('is-ready');
        p.setAttribute('aria-hidden', 'true');
      });
      triggers.forEach(t => {
        t.setAttribute('aria-expanded', 'false');
        t.closest('.sky-h__item').classList.remove('is-open');
      });
      activePanel = null;
      document.body.classList.remove('sky-h-mega-open');
    }

    /* Single Event-Delegation Click-Handler */
    header.addEventListener('click', function(e) {
      const t = e.target.closest('[data-mega-trigger]');
      if (!t || !header.contains(t)) return;
      e.preventDefault();
      const handle = t.dataset.megaTrigger;
      console.log('[sky-header] trigger click:', handle);
      const isAlreadyOpen = activePanel && activePanel.dataset.megaPanel === handle;
      if (isAlreadyOpen) closePanels(); else openPanel(handle);
    });

    /* Slider in Mega-Panels (Pfeil-Navigation) */
    header.querySelectorAll('[data-slider]').forEach(slider => {
      if (slider.dataset.sliderInit === '1') return;
      slider.dataset.sliderInit = '1';
      const track = slider.querySelector('[data-slider-track]');
      const prev = slider.querySelector('[data-slider-prev]');
      const next = slider.querySelector('[data-slider-next]');
      if (!track || !prev || !next) return;

      function updateArrows() {
        const sl = Math.round(track.scrollLeft);
        const max = track.scrollWidth - track.clientWidth;
        const overflows = track.scrollWidth > track.clientWidth + 8;
        if (!overflows) {
          prev.classList.remove('is-visible');
          next.classList.remove('is-visible');
          return;
        }
        // Prev nur sichtbar wenn deutlich gescrollt (Threshold 40px)
        if (sl > 40) prev.classList.add('is-visible');
        else prev.classList.remove('is-visible');
        // Next nur sichtbar wenn noch was nach rechts kommt (40px vor Ende)
        if (sl < max - 40) next.classList.add('is-visible');
        else next.classList.remove('is-visible');
      }

      prev.addEventListener('click', e => {
        e.preventDefault();
        e.stopPropagation();
        track.scrollBy({ left: -track.clientWidth * 0.9, behavior: 'smooth' });
      });
      next.addEventListener('click', e => {
        e.preventDefault();
        e.stopPropagation();
        track.scrollBy({ left: track.clientWidth * 0.9, behavior: 'smooth' });
      });

      track.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      /* Initial + nach Open-Animation */
      requestAnimationFrame(updateArrows);
      setTimeout(updateArrows, 100);
      setTimeout(updateArrows, 600);
      setTimeout(updateArrows, 3200);
    });

    /* 3D-Tilt + Parallax auf Mega-Cards */
    header.querySelectorAll('.sky-h__mega .sky-mc').forEach(card => {
      if (card.dataset.tilt === '1') return;
      card.dataset.tilt = '1';

      let raf = null;
      card.addEventListener('mousemove', function(e) {
        const r = card.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width - .5;
        const y = (e.clientY - r.top) / r.height - .5;
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          card.classList.add('is-tilting');
          card.style.setProperty('--tx', x.toFixed(3));
          card.style.setProperty('--ty', y.toFixed(3));
        });
      });

      card.addEventListener('mouseleave', function() {
        if (raf) cancelAnimationFrame(raf);
        card.classList.remove('is-tilting');
        card.style.setProperty('--tx', 0);
        card.style.setProperty('--ty', 0);
      });
    });

    /* Hover-Open + Mouseleave-Close komplett entfernt — Mega-Menu schließt NUR via:
       1. Klick auf Trigger nochmal
       2. Klick außerhalb des Headers
       3. X-Button (data-mega-close)
       4. ESC-Taste
    */

    /* Close-Buttons im Mega-Panel */
    header.querySelectorAll('[data-mega-close]').forEach(btn => {
      btn.addEventListener('click', closePanels);
    });

    /* Click-Outside-Close entfernt — User-Wunsch: Mega-Panel schliesst NUR via X-Button, ESC oder Trigger-Re-Click.
       Verhindert versehentliches Schliessen wenn User auf eine Card-Sub-Action (Sizes-Toggle, Bestellen-Button etc.)
       klickt oder die Maus aus dem Panel rutscht. */

    /* ESC */
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        if (activePanel) closePanels();
        closeDrawer();
      }
    });

    /* ─── Language Switcher ─── */
    const langWrap = header.querySelector('[data-sky-lang]');
    if (langWrap) {
      const langBtn = langWrap.querySelector('[data-sky-lang-toggle]');
      const langMenu = langWrap.querySelector('[data-sky-lang-menu]');
      if (langBtn && langMenu) {
        langBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          const open = langBtn.getAttribute('aria-expanded') === 'true';
          langBtn.setAttribute('aria-expanded', open ? 'false' : 'true');
          if (open) langMenu.setAttribute('hidden', '');
          else langMenu.removeAttribute('hidden');
        });
        document.addEventListener('click', function(e) {
          if (langBtn.getAttribute('aria-expanded') !== 'true') return;
          if (langWrap.contains(e.target)) return;
          langBtn.setAttribute('aria-expanded', 'false');
          langMenu.setAttribute('hidden', '');
        });
        document.addEventListener('keydown', function(e) {
          if (e.key === 'Escape' && langBtn.getAttribute('aria-expanded') === 'true') {
            langBtn.setAttribute('aria-expanded', 'false');
            langMenu.setAttribute('hidden', '');
            langBtn.focus();
          }
        });
      }
    }

    /* ─── Search Panel (Predictive Search) ─── */
    const searchToggle = header.querySelector('[data-sky-search-toggle]');
    const searchPanel = header.querySelector('[data-sky-search]');
    if (searchToggle && searchPanel) {
      const searchInput = searchPanel.querySelector('[data-sky-search-input]');
      const searchClear = searchPanel.querySelector('[data-sky-search-clear]');
      const searchCloses = searchPanel.querySelectorAll('[data-sky-search-close]');
      const stateIdle = searchPanel.querySelector('[data-sky-search-idle]');
      const stateLoading = searchPanel.querySelector('[data-sky-search-loading]');
      const stateEmpty = searchPanel.querySelector('[data-sky-search-empty]');
      const stateResults = searchPanel.querySelector('[data-sky-search-results]');
      const groupProducts = searchPanel.querySelector('[data-sky-search-products]');
      const groupProductsList = searchPanel.querySelector('[data-sky-search-products-list]');
      const groupDocs = searchPanel.querySelector('[data-sky-search-docs]');
      const groupDocsList = searchPanel.querySelector('[data-sky-search-docs-list]');
      const groupPages = searchPanel.querySelector('[data-sky-search-pages]');
      const groupPagesList = searchPanel.querySelector('[data-sky-search-pages-list]');
      const searchAll = searchPanel.querySelector('[data-sky-search-all]');

      /* Doc-Index laden (PDFs + Videos aus dokument_bibliothek-Metaobject) */
      let docIndex = [];
      const docIndexEl = document.getElementById('sky-doc-index');
      if (docIndexEl) {
        try {
          docIndex = JSON.parse(docIndexEl.textContent || '[]');
          // Vorab tokenisierte Suchbasis pro Doc
          docIndex.forEach(d => { d._s = ((d.t || '') + ' ' + (d.k || '')).toLowerCase(); });
        } catch (e) { console.warn('[sky-search] doc-index parse error', e); }
      }
      function searchDocs(q, limit) {
        if (!docIndex.length || !q) return [];
        const tokens = q.toLowerCase().split(/\s+/).filter(Boolean);
        const matches = [];
        for (let i = 0; i < docIndex.length && matches.length < limit; i++) {
          const d = docIndex[i];
          let ok = true;
          for (const t of tokens) { if (d._s.indexOf(t) === -1) { ok = false; break; } }
          if (ok) matches.push(d);
        }
        return matches;
      }
      function renderDoc(d, q) {
        const isVideo = (d.y || '').toLowerCase() === 'video';
        const icon = isVideo
          ? `<div class="sky-h__search-item__img sky-h__search-item__img--placeholder"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><polygon points="5 3 19 12 5 21 5 3"/></svg></div>`
          : `<div class="sky-h__search-item__img sky-h__search-item__img--placeholder"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="9" y1="15" x2="15" y2="15"/></svg></div>`;
        const kat = d.k ? escapeHtml(String(d.k).trim()) : (isVideo ? 'Video' : 'PDF');
        const tag = isVideo ? 'Video' : 'PDF';
        const href = d.u || '/pages/anleitungen';
        const targetAttr = d.u ? ' target="_blank" rel="noopener noreferrer"' : '';
        return `<a class="sky-h__search-item" href="${escapeHtml(href)}"${targetAttr}>
          ${icon}
          <div class="sky-h__search-item__body">
            <span class="sky-h__search-item__title">${highlight(d.t || '', q)}</span>
            <span class="sky-h__search-item__meta"><span class="sky-h__search-item__tag">${tag}</span>${kat ? ' · ' + kat : ''}</span>
          </div>
          <svg class="sky-h__search-item__arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M5 12h14M13 6l6 6-6 6"/></svg>
        </a>`;
      }

      function setState(name) {
        if (stateIdle) stateIdle.hidden = name !== 'idle';
        if (stateLoading) stateLoading.hidden = name !== 'loading';
        if (stateEmpty) stateEmpty.hidden = name !== 'empty';
        if (stateResults) stateResults.hidden = name !== 'results';
      }

      function openSearch() {
        searchPanel.classList.add('is-open');
        searchPanel.setAttribute('aria-hidden', 'false');
        searchToggle.setAttribute('aria-expanded', 'true');
        document.body.classList.add('sky-h-search-open');
        setTimeout(() => searchInput && searchInput.focus(), 80);
      }
      function closeSearch() {
        searchPanel.classList.remove('is-open');
        searchPanel.setAttribute('aria-hidden', 'true');
        searchToggle.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('sky-h-search-open');
      }

      searchToggle.addEventListener('click', function(e) {
        e.preventDefault();
        if (searchPanel.classList.contains('is-open')) closeSearch();
        else openSearch();
      });
      searchCloses.forEach(b => b.addEventListener('click', closeSearch));
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && searchPanel.classList.contains('is-open')) closeSearch();
      });

      function escapeHtml(s) {
        return String(s == null ? '' : s)
          .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
      }
      function highlight(text, q) {
        const safe = escapeHtml(text);
        if (!q) return safe;
        const re = new RegExp('(' + q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'ig');
        return safe.replace(re, '<mark>$1</mark>');
      }
      function parsePriceValue(p) {
        if (p == null) return NaN;
        if (typeof p === 'number') return p;
        const cleaned = String(p).replace(/[^\d.,-]/g, '').replace(',', '.');
        return parseFloat(cleaned);
      }
      function formatMoney(p) {
        const v = parsePriceValue(p);
        if (!isFinite(v)) return '';
        const round = Math.round(v) === v;
        try {
          return new Intl.NumberFormat('de-CH', {
            style: 'currency',
            currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'CHF',
            minimumFractionDigits: round ? 0 : 2,
            maximumFractionDigits: 2,
          }).format(v);
        } catch (e) { return 'CHF ' + (round ? v.toFixed(0) : v.toFixed(2)); }
      }

      function renderProduct(p, q) {
        const img = p.featured_image && p.featured_image.url
          ? `<img class="sky-h__search-item__img" src="${p.featured_image.url}&width=120" alt="" loading="lazy" width="56" height="56">`
          : `<div class="sky-h__search-item__img sky-h__search-item__img--placeholder"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/></svg></div>`;
        const pMin = parsePriceValue(p.price_min);
        const pMax = parsePriceValue(p.price_max);
        const pSingle = parsePriceValue(p.price);
        let priceHtml = '';
        if (isFinite(pMin) && isFinite(pMax) && pMin !== pMax) {
          priceHtml = `<span class="sky-h__search-item__price"><span class="sky-h__search-item__price-pre">ab</span> ${formatMoney(pMin)}</span>`;
        } else if (isFinite(pSingle) || isFinite(pMin)) {
          priceHtml = `<span class="sky-h__search-item__price">${formatMoney(isFinite(pSingle) ? pSingle : pMin)}</span>`;
        }
        // Untertitel: Shopify Produkt-Typ (gepflegt im Admin pro Produkt), Fallback Vendor
        const meta = p.type ? escapeHtml(p.type) : (p.vendor ? escapeHtml(p.vendor) : '');
        return `<a class="sky-h__search-item" href="${escapeHtml(p.url)}">
          ${img}
          <div class="sky-h__search-item__body">
            <span class="sky-h__search-item__title">${highlight(p.title, q)}</span>
            ${meta ? `<span class="sky-h__search-item__meta">${meta}</span>` : ''}
          </div>
          ${priceHtml}
          <svg class="sky-h__search-item__arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M5 12h14M13 6l6 6-6 6"/></svg>
        </a>`;
      }
      function renderPage(p, q, kind) {
        const icon = kind === 'article'
          ? `<div class="sky-h__search-item__img sky-h__search-item__img--placeholder"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="8" y1="13" x2="16" y2="13"/><line x1="8" y1="17" x2="16" y2="17"/></svg></div>`
          : `<div class="sky-h__search-item__img sky-h__search-item__img--placeholder"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/></svg></div>`;
        return `<a class="sky-h__search-item" href="${escapeHtml(p.url)}">
          ${icon}
          <div class="sky-h__search-item__body">
            <span class="sky-h__search-item__title">${highlight(p.title, q)}</span>
            <span class="sky-h__search-item__meta">${kind === 'article' ? 'Beitrag' : 'Seite'}</span>
          </div>
          <svg class="sky-h__search-item__arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M5 12h14M13 6l6 6-6 6"/></svg>
        </a>`;
      }

      /* Performance: API-Cache (Query → Response), max 25 Einträge LRU */
      const apiCache = new Map();
      const apiCacheMax = 25;
      function cacheGet(k) {
        if (!apiCache.has(k)) return null;
        const v = apiCache.get(k);
        apiCache.delete(k); apiCache.set(k, v); // LRU touch
        return v;
      }
      function cacheSet(k, v) {
        if (apiCache.size >= apiCacheMax) apiCache.delete(apiCache.keys().next().value);
        apiCache.set(k, v);
      }

      function renderApiResults(q, r) {
        const products = r.products || [];
        const pages = r.pages || [];
        const articles = r.articles || [];
        if (products.length) {
          groupProductsList.innerHTML = products.map(p => renderProduct(p, q)).join('');
          groupProducts.hidden = false;
        } else { groupProducts.hidden = true; }
        if (pages.length || articles.length) {
          groupPagesList.innerHTML = [
            ...pages.map(p => renderPage(p, q, 'page')),
            ...articles.map(a => renderPage(a, q, 'article')),
          ].join('');
          groupPages.hidden = false;
        } else { groupPages.hidden = true; }
        if (searchAll) searchAll.href = '/search?q=' + encodeURIComponent(q) + '&type=product,page,article';
      }

      /* Pre-warm: Verbindung zu Shopify-Search-Domain aufbauen sobald Such-Panel öffnet */
      let prewarmed = false;
      function prewarmSearch() {
        if (prewarmed) return; prewarmed = true;
        try {
          const link = document.createElement('link');
          link.rel = 'preconnect'; link.href = location.origin; link.crossOrigin = '';
          document.head.appendChild(link);
        } catch (e) {}
      }

      let fetchTimer = null;
      let loadingTimer = null;
      let fetchCtrl = null;
      let lastRenderedQ = '';

      function doSearch(q) {
        if (fetchCtrl) fetchCtrl.abort();

        // Cache-Hit: sofort rendern, kein Spinner, kein Fetch
        const cached = cacheGet(q);
        if (cached) {
          clearTimeout(loadingTimer);
          const docs = searchDocs(q, 6);
          if (!cached.products?.length && !cached.pages?.length && !cached.articles?.length && !docs.length) {
            setState('empty'); return;
          }
          if (docs.length) {
            groupDocsList.innerHTML = docs.map(d => renderDoc(d, q)).join('');
            groupDocs.hidden = false;
          } else { groupDocs.hidden = true; }
          renderApiResults(q, cached);
          setState('results');
          lastRenderedQ = q;
          return;
        }

        // 1) Docs SOFORT zeigen (clientseitig, 0ms Latenz)
        const docs = searchDocs(q, 6);
        if (docs.length) {
          groupDocsList.innerHTML = docs.map(d => renderDoc(d, q)).join('');
          groupDocs.hidden = false;
          // Produkte/Pages temporär leeren bis API antwortet (keine alten Inhalte zeigen)
          if (lastRenderedQ !== q) {
            groupProductsList.innerHTML = '';
            groupProducts.hidden = true;
            groupPagesList.innerHTML = '';
            groupPages.hidden = true;
          }
          setState('results');
        } else {
          // Keine Doc-Treffer → Spinner mit Delay (max. 200ms erst zeigen)
          groupDocs.hidden = true;
          clearTimeout(loadingTimer);
          loadingTimer = setTimeout(() => {
            // Nur Spinner wenn weiterhin kein Result da
            if (stateResults.hidden) setState('loading');
          }, 200);
        }

        // 2) API-Fetch parallel
        fetchCtrl = new AbortController();
        const url = '/search/suggest.json?q=' + encodeURIComponent(q)
          + '&resources[type]=product,page,article'
          + '&resources[limit]=6&resources[limit_scope]=each'
          + '&resources[options][fields]=title,product_type,variants.title,variants.sku,variants.barcode,vendor,tag';
        fetch(url, { signal: fetchCtrl.signal, headers: { 'Accept': 'application/json' } })
          .then(r => r.json())
          .then(data => {
            clearTimeout(loadingTimer);
            const r = (data && data.resources && data.resources.results) || {};
            cacheSet(q, r);
            const products = r.products || [];
            const pages = r.pages || [];
            const articles = r.articles || [];
            if (!products.length && !pages.length && !articles.length && !docs.length) {
              setState('empty'); return;
            }
            renderApiResults(q, r);
            setState('results');
            lastRenderedQ = q;
          })
          .catch(err => {
            if (err && err.name === 'AbortError') return;
            clearTimeout(loadingTimer);
            console.warn('[sky-header] search error', err);
            if (!docs.length) setState('empty');
          });
      }

      searchInput.addEventListener('focus', prewarmSearch, { once: true });
      searchInput.addEventListener('input', function() {
        const q = searchInput.value.trim();
        if (searchClear) searchClear.hidden = q.length === 0;
        clearTimeout(fetchTimer);
        clearTimeout(loadingTimer);
        if (q.length < 2) {
          setState('idle');
          return;
        }
        // Debounce 60ms (vorher 180ms) — schnelles Tippen wird trotzdem geschluckt
        fetchTimer = setTimeout(() => doSearch(q), 60);
      });
      if (searchClear) {
        searchClear.addEventListener('click', function() {
          searchInput.value = '';
          searchClear.hidden = true;
          setState('idle');
          searchInput.focus();
        });
      }
    }

    /* ─── Cart-Drawer Open/Close + Outside-Click + ESC + Backdrop ─── */
    (function initCartDrawerBackdrop() {
      // Backdrop-Element einfügen, wenn nicht vorhanden
      if (!document.querySelector('.sky-cart-drawer-backdrop')) {
        const bd = document.createElement('div');
        bd.className = 'sky-cart-drawer-backdrop';
        bd.setAttribute('aria-hidden', 'true');
        document.body.appendChild(bd);
      }
      const backdrop = document.querySelector('.sky-cart-drawer-backdrop');

      // Inject Open-State-CSS einmalig — Drawer-Slide an body.cart-drawer-open koppeln.
      // So funktioniert das Öffnen einheitlich, egal ob via Cart-Icon (mein Handler) oder
      // via ATC-Fallback (sky-pdp-hero.liquid, sky-product-hero.liquid), die ebenfalls
      // body.cart-drawer-open setzen.
      if (!document.getElementById('sky-cart-drawer-open-style')) {
        const s = document.createElement('style');
        s.id = 'sky-cart-drawer-open-style';
        s.textContent =
          '#Cart-Drawer{transition:transform .35s cubic-bezier(.25,.46,.45,.94);}' +
          'body.cart-drawer-open #Cart-Drawer{visibility:visible !important;transform:translateX(0%) !important;-webkit-transform:translateX(0%) !important;}';
        document.head.appendChild(s);
      }

      function openCartDrawer() {
        const cd = document.querySelector('#Cart-Drawer');
        if (!cd) return;
        document.body.classList.add('cart-drawer-open');
        const wrapper = document.getElementById('wrapper');
        if (wrapper) wrapper.classList.add('open-cc');
        try { cd.focus(); } catch(e) {}
      }

      function closeCartDrawer() {
        const cd = document.querySelector('#Cart-Drawer');
        if (!cd) return;
        document.body.classList.remove('cart-drawer-open');
        const wrapper = document.getElementById('wrapper');
        if (wrapper) wrapper.classList.remove('open-cc');
        // Räume potenzielle inline-Styles auf, die app.min.js's GSAP gesetzt haben könnte
        cd.style.transform = '';
        cd.style.visibility = '';
      }

      // Cart-Icon Click → Drawer öffnen (Bypass für app.min.js's fragile CartDrawer-Init)
      document.addEventListener('click', function(e) {
        if (!e.target || !e.target.closest) return;
        const toggle = e.target.closest('#cart-drawer-toggle, .sky-h__action--cart');
        if (!toggle) return;
        // Auf der dedizierten /cart Seite normales Navigieren erlauben
        if (document.body.classList.contains('template-cart')) return;
        e.preventDefault();
        if (document.body.classList.contains('cart-drawer-open')) {
          closeCartDrawer();
        } else {
          openCartDrawer();
        }
      });

      // Body-Klassen-Observer: Backdrop togglen wenn cart-drawer-open
      const bodyObs = new MutationObserver(() => {
        const open = document.body.classList.contains('cart-drawer-open');
        backdrop.classList.toggle('is-active', open);
      });
      bodyObs.observe(document.body, { attributes: true, attributeFilter: ['class'] });

      // Click auf Backdrop → schließen
      backdrop.addEventListener('click', closeCartDrawer);

      // X-Button im Drawer-Header → schließen (Bypass für app.min.js's GSAP-Path)
      document.addEventListener('click', function(e) {
        if (!e.target || !e.target.closest) return;
        if (!document.body.classList.contains('cart-drawer-open')) return;
        const x = e.target.closest('.sky-cart-drawer > header .thb-close, #Cart-Drawer .thb-close');
        if (x) {
          e.preventDefault();
          closeCartDrawer();
        }
      });

      // Legacy .click-capture (Z-index 500, von app.css) → ebenfalls schließen
      const cc = document.querySelector('.click-capture');
      if (cc) cc.addEventListener('click', closeCartDrawer);

      // Click außerhalb (z.B. auf Page-Content) → schließen
      document.addEventListener('click', function(e) {
        if (!document.body.classList.contains('cart-drawer-open')) return;
        const cd = document.querySelector('#Cart-Drawer');
        if (!cd) return;
        if (cd.contains(e.target)) return;
        // Quote-/Offerten-Modal liegt ÜBER dem Drawer, aber außerhalb von #Cart-Drawer im DOM.
        // Klicks darin (inkl. Close-Button + Overlay) dürfen den Drawer NICHT schließen,
        // sonst verschwindet er unter dem Modal. Solange das Modal offen ist: Drawer offen lassen.
        if (document.body.classList.contains('quote-modal-open')) return;
        if (e.target.closest && e.target.closest('#quote-request-modal, #quote-request-overlay')) return;
        // Click-Toggle auf Cart-Icon selbst nicht abfangen (öffnet/schließt schon selber)
        const cartToggle = e.target.closest('#cart-drawer-toggle, .sky-h__action--cart');
        if (cartToggle) return;
        closeCartDrawer();
      }, true);

      // ESC zum Schließen
      document.addEventListener('keydown', function(e) {
        if (e.key !== 'Escape') return;
        if (!document.body.classList.contains('cart-drawer-open')) return;
        // Offerten-Modal offen → ESC soll nur das Modal schließen, nicht den Drawer darunter.
        // (sky-header.js läuft vor quote-request.js, daher ist quote-modal-open hier noch gesetzt.)
        if (document.body.classList.contains('quote-modal-open')) return;
        closeCartDrawer();
      });
    })();

    /* ─── Mobile-Drawer ─── */
    const burger = header.querySelector('.sky-h__burger');
    const drawer = header.querySelector('.sky-h__drawer');

    function openDrawer() {
      if (!drawer) return;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      burger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('sky-h-drawer-open');
    }

    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (burger) burger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('sky-h-drawer-open');
    }

    if (burger && drawer) {
      burger.addEventListener('click', openDrawer);
      drawer.querySelectorAll('[data-drawer-close]').forEach(b => {
        b.addEventListener('click', closeDrawer);
      });
    }

    /* Drawer-Sub-Expand */
    if (drawer) {
      drawer.querySelectorAll('[data-drawer-expand]').forEach(btn => {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          const handle = btn.dataset.drawerExpand;
          const sub = drawer.querySelector(`[data-drawer-sub="${handle}"]`);
          if (!sub) return;
          const isOpen = btn.getAttribute('aria-expanded') === 'true';
          if (isOpen) {
            sub.hidden = true;
            btn.setAttribute('aria-expanded', 'false');
          } else {
            sub.hidden = false;
            btn.setAttribute('aria-expanded', 'true');
          }
        });
      });
    }

    /* sky-mm-link-tap-expand START */
    if (drawer) {
      drawer.querySelectorAll('.sky-h__drawer-section').forEach(function(section){
        var link = section.querySelector(':scope > a.sky-h__drawer-link');
        var btn  = section.querySelector(':scope > button.sky-h__drawer-expand[data-drawer-expand]');
        if (!link || !btn) return;
        link.addEventListener('click', function(e){
          var isOpen = btn.getAttribute('aria-expanded') === 'true';
          if (isOpen) return; // Submenü schon offen → normaler Navigations-Klick
          e.preventDefault();
          e.stopPropagation();
          // Andere offene Sub-Menüs auf gleicher Ebene schliessen
          drawer.querySelectorAll('.sky-h__drawer-expand[aria-expanded="true"]').forEach(function(otherBtn){
            if (otherBtn === btn) return;
            var otherHandle = otherBtn.dataset.drawerExpand;
            var otherSub = drawer.querySelector('[data-drawer-sub="'+otherHandle+'"]');
            if (otherSub) otherSub.hidden = true;
            otherBtn.setAttribute('aria-expanded', 'false');
          });
          btn.click();
        });
      });
    }
    /* sky-mm-link-tap-expand END */

    /* ─── Sizes-Toggle pro Mega-Card (zeigt Varianten-Größen + ab-Preise) ─── */
    header.querySelectorAll('[data-sky-sizes-toggle]').forEach(function(btn){
      btn.addEventListener('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        var card = btn.closest('.sky-mc');
        var panel = card && card.querySelector('[data-sky-sizes-panel]');
        if (!panel) return;
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        if (isOpen) {
          panel.hidden = true;
          btn.setAttribute('aria-expanded', 'false');
        } else {
          panel.hidden = false;
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });

    /* ─── Cart-Count Badge: bei 0 verstecken, sonst zeigen.
       app.min.js aktualisiert den Text via AJAX-Cart-Updates aber setzt unsere `is-zero` Class nicht.
       MutationObserver schaut auf Text-Änderungen und togglet die Class entsprechend. */
    header.querySelectorAll('.sky-h__cart-count').forEach(function(badge){
      function syncZero() {
        var n = parseInt((badge.textContent || '').trim(), 10);
        if (!isFinite(n) || n <= 0) badge.classList.add('is-zero');
        else badge.classList.remove('is-zero');
      }
      syncZero();
      new MutationObserver(syncZero).observe(badge, { childList: true, characterData: true, subtree: true });
    });

    /* ─── Sticky Scroll-State ─── */
    header.classList.add('is-sticky');
    header.classList.remove('sky-h--tucked');
    function onScroll() {
      const scrolled = window.scrollY > 8;
      header.classList.toggle('is-scrolled', scrolled);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
})();
